import { render, staticRenderFns } from "./BannerImage.vue?vue&type=template&id=0efddf22&scoped=true&"
import script from "./BannerImage.vue?vue&type=script&lang=js&"
export * from "./BannerImage.vue?vue&type=script&lang=js&"
import style0 from "./BannerImage.vue?vue&type=style&index=0&id=0efddf22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efddf22",
  null
  
)

export default component.exports